import { Alert } from '@efexteam/components';
import { Typography, CircularProgress, Box } from '@mui/material';
import clsx from 'clsx';
import { RateValidationAlertProps } from './RateValidationAlert.types';
import RateValidationAlertStyles from './RateValidationAlert.styles';

export const RateValidationAlert = ({
  alertProps,
  className,
}: RateValidationAlertProps) => {
  const { shouldShow, severity, message, showLoading, loadingMessage } =
    alertProps;

  if (!shouldShow) {
    return null;
  }

  return (
    <Alert
      severity={severity}
      className={clsx(RateValidationAlertStyles.alertContainer, className)}
    >
      <Typography
        variant="caption"
        component="div"
        className={RateValidationAlertStyles.messageText}
      >
        {message}
      </Typography>

      {showLoading && loadingMessage && (
        <Box className={RateValidationAlertStyles.loadingContainer}>
          <CircularProgress size={12} />
          <Typography
            variant="caption"
            className={RateValidationAlertStyles.loadingText}
          >
            {loadingMessage}
          </Typography>
        </Box>
      )}
    </Alert>
  );
};

RateValidationAlert.displayName = 'RateValidationAlert';

export default RateValidationAlert;
